
import masterOfCoinAbi from "../assets/abis/masterOfCoin.json";
import { getContract } from "../utils/contract";
import { useQuery, useMutation } from "react-query";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { MASTER_OF_COIN } from "../utils/constants";
import { BigNumber } from "ethers";


export const getNodeChecksum = (
  name,
  createdAt,
  tier,
  address
) => {
  return `${name}${createdAt}${tier}${address.toLowerCase().slice(2)}`;
};

export async function getNodeFee(contract, nodeId, tier) {
  try {
    return contract.methods.getFee(nodeId, tier).call();
  } catch (e) {
    console.log(e);
  }
}

export const useMasterOfCoinContract = () => {
  const web3context = useSelector((state) => state.web3.web3context);
  const ethereum = web3context?.library;

  return [
    ethereum,
    useMemo(
      () => getContract(masterOfCoinAbi, MASTER_OF_COIN, ethereum),
      [ethereum]
    ),
  ];
};


export const useGetDueDate = (nodeId) => {
  const [provider, contract] = useMasterOfCoinContract();

  async function getDueDates() {
    try {
      return contract.methods.getDueDate(nodeId).call();
    } catch (e) {
      console.log(e);
    }
  }

  return useQuery(["getDueDates", nodeId], getDueDates, {
    enabled: Boolean(provider),
    refetchInterval: 15000,
  });
};


export const useGetIsDelinquent = (nodeId) => {
  const [provider, contract] = useMasterOfCoinContract();

  async function isDelinquent() {
    try {
      return contract.methods.isDelinquent(nodeId).call();
    } catch (e) {
      console.log(e);
    }
  }

  return useQuery(["isDelinquent", nodeId], isDelinquent, {
    enabled: Boolean(provider),
    refetchInterval: 15000,
  });
};


export const usePayFees = () => {
  const web3context = useSelector((state) => state.web3.web3context);
  const [provider, contract] = useMasterOfCoinContract();
  const account = web3context?.account;

  async function payFees(nodeIds, tier) {
    if (!provider) {
      return;
    }

    try {
      let totalFees = BigNumber.from(0);
      for (const id of nodeIds) {
        totalFees = totalFees.add(await getNodeFee(contract, id, tier));
      }

      return contract.methods.payFees(nodeIds, tier).send({
        from: account,
        value: totalFees.toString(),
      });
    } catch (e) {
      console.log(e);
    }
  }

  const { isLoading, mutateAsync } = useMutation(
    ([nodeIds, tier]) => payFees(nodeIds, tier)
  );

  return { payFees: mutateAsync, isLoading };
};